import * as v1Exports from '~libSass/base/_exports.sass';
import * as v2Colors from '~libSass/v2/_colors.sass';

export const getColors = () => {
  return {...v1Exports, ...v2Colors};
};
